import Loader from "react-spinners/MoonLoader";

const Spinner = (props) => {
  return (
    <Loader
      color={"#265436"}
      loading={true}
      // cssOverride={override}
      size={25}
      aria-label="Loading Spinner"
      data-testid="loader"
      {...props}
    />
  )
}

export default Spinner;